
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 154 132","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M84.938 128.766l12.072-10.6h46.657a9.524 9.524 0 009.523-9.524v-98.6A9.524 9.524 0 00143.667.52H10.333A9.524 9.524 0 00.81 10.042v98.6a9.524 9.524 0 009.523 9.524h47.705l14.938 11.095a9.524 9.524 0 0011.962-.495zm4.89-29.647L78.153 109.38 64.342 99.12H19.858V19.566h114.286V99.12H89.829z"}}),_c('path',{attrs:{"d":"M119.857 31.138v19.047H34.143V31.138h85.714zM91.286 59.709v19.048H34.143V59.709h57.143z"}})])])
          )
        }
      }
    